import { useMemo } from "react";
import { withSettingDefaults } from "../../shared/models";
import { useMe, useSettings } from "../data/queries";

/** Display preferences every widget needs: timezone, units, clock format. */
export function useHousehold() {
  const me = useMe();
  const settings = useSettings();
  // The copy saved on this device may be from before a setting existed; fill the gaps.
  const s = useMemo(() => withSettingDefaults(settings.data), [settings.data]);
  return {
    timeZone: me.data?.household.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
    householdName: me.data?.household.name ?? "Home",
    isAdmin: me.data?.isAdmin ?? false,
    settings: s,
  };
}
